import React from "react";
import heroImage from "../../assets/images/home/webp/leftParrotWithPoy.webp";
import HeroSectionForm from "./HeroSectionForm";

function HeroSection() {
  return (
    <div className="flex flex-col lg:flex-row w-screen lg:gap-20 lg:justify-between lg:pb-5">
      <div className="pt-6 lg:pt-[20px]">
        <h2 className="lg:max-w-[700px] text-[32px] leading-[40px] lg:text-[52px] text-[#00487A] lg:leading-[72px] font-bold pl-6 lg:pl-[120px]">
          The People have Spoken -{" "}
          <span className="text-[#FB7C2F]">Crowned Product of the Year</span>
        </h2>
        <div className="flex flex-col-reverse lg:flex-row">
          <img
            src={heroImage}
            alt="hero"
            className="my-6 lg:my-0 lg:w-[415px] self-center lg:h-[595px] w-[363px] h-[509px]"
          />
          <p className="pt-4  px-6 lg:ml-10 lg:px-0 text-[#4D4D4D] lg:max-w-[336px] lg:pt-6">
            Presenting ManipalCigna Sarvah Health Insurance, truly complete
            health insurance solution, now crowned Product of the Year 2025,
            that offers you an Essential Shield, Infinite Power and Instant
            Peace. This This plan has 3 variants ManipalCigna{" "}
            <span className="font-bold text-[#FB7C2F]">Pratham, Uttam</span> and{" "}
            <span className="font-bold text-[#FB7C2F]">Param</span> each
            tailored to provide the infinite coverage, infinite security and
            infinite power.
            <br />
            <span className="lg:px-0 text-[#4D4D4D] text-[12px] lg:max-w-[336px] lg:pt-6">
              (Winner Health Insurance Category. Survey of 1800 people by
              NielsenIQ across categories.)
            </span>
          </p>
        </div>
      </div>
      <HeroSectionForm />
    </div>
  );
}

export default HeroSection;
